export default __webpack_public_path__ + "static/media/footer-illustration.3d4e052b.svg";